import { Map as ImmutableMap, OrderedMap } from 'immutable';
import compose from 'transmute/compose';
const convertPropertiesToMap = properties => {
  return properties.reduce((propertyMap, property) => {
    return propertyMap.set(property.get('name'), property);
  }, ImmutableMap());
};
const formatContact = contact => {
  const contactWithUpdatedProperties = contact.update('properties', convertPropertiesToMap);
  if (!contactWithUpdatedProperties.has('company')) {
    return contactWithUpdatedProperties;
  }
  return contactWithUpdatedProperties.updateIn(['company', 'properties'], convertPropertiesToMap);
};
const formatContacts = visitorsData => visitorsData.update('deckVisitors', deckVisitors => deckVisitors.map(deckVisitor => {
  const contact = deckVisitor.get('contact');
  if (!contact) {
    return deckVisitor;
  }
  return deckVisitor.set('contact', formatContact(contact));
}));
const formatDeckVisitors = visitorsData => {
  return visitorsData.update('deckVisitors', deckVisitors => deckVisitors.reduce((deckVisitorMap, deckVisitor) => deckVisitorMap.set(deckVisitor.get('vid'), deckVisitor), OrderedMap()));
};
export default compose(formatContacts, formatDeckVisitors);